import SpriteSymbol from "../../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "summary_statistic",
  "use": "summary_statistic-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"summary_statistic\"><path d=\"M3.5 11.666V6.334A2.837 2.837 0 016.334 3.5h5.332A2.837 2.837 0 0114.5 6.334V11H16V6.334A4.333 4.333 0 0011.666 2H6.334A4.333 4.333 0 002 6.334v5.332A4.333 4.333 0 006.334 16H11v-1.5H6.334A2.837 2.837 0 013.5 11.666zM9.75 12V8h-1.5v4h1.5zM16 14.5V12h-1.5v2.5H12V16h2.5v2H16v-2h2v-1.5h-2zM5.25 12h1.5V9h-1.5v3zm7.5-6h-1.5v6h1.5V6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol